import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { DataService } from 'src/app/services/data.service';
import { Constants } from 'src/app/core/constants';
import { ProposalImage } from 'src/app/models/proposal-image';
import { FormFileToBeUploaded } from 'src/app/models/internal/formfile-tobe-uploaded';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { LocalstorageService } from 'src/app/services/localstorage.service';

class FileUploadSnippet {
  pending: boolean = false;
  status: string = 'init';

  constructor(public src: string, public file: File) {}
}

@Component({
  selector: 'app-adhocrequest',
  templateUrl: './adhocrequest.component.html',
  styleUrls: ['./adhocrequest.component.scss']
})
export class AdhocrequestComponent extends BasePage implements OnInit {
  adhocExcelUploadForm = this.fb.group({
    file: [null, Validators.required],
});
@Input() isUpdateMode: boolean;
fileStream = '';
errorList: String[] = null;
selectedFile: FileUploadSnippet;

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private cd: ChangeDetectorRef,
    private dataService: DataService,
    localstorageService: LocalstorageService,
    logger: NGXLogger,
    appSettings: AppSettings 
  ) { super(localstorageService, logger, appSettings); }

  ngOnInit() {
  }

  onFileChanged(imageInput: any) {
    this.errorList = null;
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    this.errorList = null;
    reader.addEventListener('load', (event: any) => {
      this.selectedFile = new FileUploadSnippet(event.target.result, file);
          this.fileStream = event.target.result;
          this.selectedFile.pending = true;
          const formFileToBeUploaded: FormFileToBeUploaded = {
              File: this.selectedFile.file,
          }
        this.dataService
          .uploadAdHocExcel(
            formFileToBeUploaded.File
          )
          .subscribe((response: any) => {
            if (response != null) {
                  this.logDebug('excel upload response = ' + response);
                  if(!response.Success)
                  {
                    this.logDebug('excel upload failed');
                    this.errorList = response.Messages;
                  }
                  else
                  {
                    this.toastService.success(Constants.SUCCESS_FILE_UPLOAD);
                  }
              }
          });
        });
    reader.readAsDataURL(file);
    
}
}
